import { useFileOperations } from '@dev-streetbeat/chat/react';
import { DownloadIcon, ExpandIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from 'shared/components/ui/dialog';
import { useChatScrollToBottom } from '../../../chat/hooks';

import type { File } from '@dev-streetbeat/chat/types';

import styles from './ImageFileArtifact.module.scss';
import { createLogger } from 'shared/logger';

const log = createLogger('ImageFileArtifact');

type Props = {
  file: File;
};

export const ImageFileArtifact: React.FC<Props> = ({ file }) => {
  const [url, setUrl] = useState('');

  const { getFileUrl, downloadFile } = useFileOperations();
  const { scrollToBottom } = useChatScrollToBottom();

  useEffect(() => {
    getFileUrl(file.id).then(setUrl).catch((error) => log.error('load image url failed', { fileId: file.id, error }));
  }, [file.id]);

  const download = async () => {
    try {
      const fileName = file.name;
      const fileId = file.id;
      const response = await downloadFile(fileId);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(response);
      link.download = fileName;
      link.click();
    } catch (error) {
      log.error('image download failed', { fileId: file.id, error });
    }
  };

  const openDialog = async () => {
    // update url on click

    try {
      const url = await getFileUrl(file.id);
      setUrl(url);
    } catch (error) {
      log.error('load image url failed', { fileId: file.id, error });
    }
  };

  const handleImageLoaded = () => {
    requestAnimationFrame(() => {
      scrollToBottom(true);
    });
  };

  if (!url) {
    return null;
  }

  return (
    <>
      <div className={styles.imageContainer}>
        <div className={styles.imageOverlayActions}>
          <div className={styles.overlayButton} onClick={download}>
            <DownloadIcon className="size-4" />
          </div>
          <Dialog>
            <DialogTrigger asChild>
              <div className={styles.overlayButton}>
                <ExpandIcon className="size-4" onClick={openDialog} />
              </div>
            </DialogTrigger>
            <DialogContent className={styles.dialogContentWrapper} title={file.name}>
              <div className={styles.dialogContent}>
                <img src={url} className="w-fit" alt={file.name} />
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <img className={styles.imageContent} src={url} alt={file.name} onLoad={handleImageLoaded} />
      </div>
      <div id={file.id.toString()} className="image-attachment-scroll-margin"></div>
    </>
  );
};
